'use client';
import { useEffect } from 'react';

/**
 * Inyecta los scripts/tags administrados desde el CMS (Ajustes generales →
 * Bandeja de scripts). Maneja HTML arbitrario (GA, GTM, Meta Pixel, Clarity,
 * <meta> de Search Console, <noscript>, etc.) y EJECUTA las etiquetas <script>
 * (recreándolas, porque innerHTML no las ejecuta). Cada item se coloca según su
 * `placement`: head | body_start | body_end.
 *
 * Recibe los items ya filtrados (solo activos) desde el layout (server-side).
 */
export default function SiteScripts({ items }) {
  useEffect(() => {
    if (!Array.isArray(items) || items.length === 0) return;
    // Evita doble inyección (StrictMode en dev / remounts).
    if (typeof window === 'undefined' || window.__siteScriptsInjected) return;
    window.__siteScriptsInjected = true;

    items.forEach((it) => {
      if (!it || !it.code || it.active === false) return;

      const target = it.placement === 'head' ? document.head : document.body;
      const prepend = it.placement === 'body_start';

      const tpl = document.createElement('template');
      tpl.innerHTML = it.code;

      const frag = document.createDocumentFragment();
      Array.from(tpl.content.childNodes).forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SCRIPT') {
          // Recrear el <script> para que el navegador lo ejecute.
          const s = document.createElement('script');
          for (const attr of Array.from(node.attributes)) {
            s.setAttribute(attr.name, attr.value);
          }
          s.text = node.textContent || '';
          frag.appendChild(s);
        } else {
          frag.appendChild(node.cloneNode(true));
        }
      });

      if (prepend && target.firstChild) {
        target.insertBefore(frag, target.firstChild);
      } else {
        target.appendChild(frag);
      }
    });
  }, [items]);

  return null;
}
